import React from 'react'
import {
	StyledPageContainer,
	StyledProductsContainer
} from './../../../components/containers/flex-container.component'
import Yup from './../../../helpers/custom-yup'
import ProductGridItem from './product-grid-item.component'
import { SelectInput } from '../../../components/form-components/inputs.component.jsx'
import { Formik, Form } from 'formik'
import { isMobile } from '../../../services/breakpoints.service'
import * as config from 'config'
import { StoreProductOverview } from '../../../components'
import Select from 'react-select'
import { selectStyles } from '../../../components/form-components/styles/select.style'

const baseUrl = `${config.contentUrl}loja/produto/`

const sortOptions = [
	{ value: 'creationdate', label: 'Novidades' },
	{ value: 'pointsdesc', label: 'Pontos (maior-menor)' },
	{ value: 'pointsasc', label: 'Pontos (menor-maior)' },
	{ value: 'nameasc', label: 'Nome (A-Z)' },
	{ value: 'namedesc', label: 'Nome (Z-A)' }
]

class ProductsGrid extends React.Component {
	constructor(props) {
		super(props)
		this.state = { products: [], currentOption: sortOptions[0] }
	}

	componentDidMount() {
		this.fetchData()
	}

	fetchData() {
		this.props
			.fetchData({ sord: this.state.currentOption.value })
			.then(({ data }) => this.setState({ products: data }))
	}

	onValueChange(sord) {
		this.setState({ currentOption: sord }, () => this.fetchData())
	}

	render() {
		return (
			<StyledPageContainer>
				<div className="sord-options-container">
					<div className="sord-options-sub-container">
						<label htmlFor="sord-options">Ordernar por</label>
						<div className="sord-select-container">
							<Select
								inputId={'sort-option'}
								name={'sort-option-name'}
								options={sortOptions}
								isClearable={false}
								value={this.state.currentOption}
								isSearchable={true}
								className={'select'}
								styles={selectStyles}
								style={{ zIndex: 10 }}
								isDisabled={false}
								defaultValue={sortOptions[0]}
								onChange={value => this.onValueChange(value)}
								backspaceRemovesValue={false}
								menuPortalTarget={document.body}
								placeholder={'Selecione...'}
							/>
						</div>
					</div>
				</div>
				<StyledProductsContainer>
					<React.Fragment>
						{this.state.products.map(
							(
								{
									id,
									points,
									imageUrl,
									description,
									secondPrice,
									secondPoints,
									pointsForSubscribers,
									priceNotMember,
									priceForMember
								},
								index
							) => {
								return (
									<StoreProductOverview
										key={index}
										id={id}
										points={points}
										name={description}
										src={`${baseUrl}${imageUrl}`}
										pointsForSubscribers={pointsForSubscribers}
										priceNotMember={priceNotMember}
										priceForMember={priceForMember}
									/>
								)
							}
						)}
					</React.Fragment>
				</StyledProductsContainer>
			</StyledPageContainer>
		)
	}
}

export default ProductsGrid
